<template>
  <el-popover placement="bottom" v-model="popoverVisible" width="270" trigger="click">
    <el-button v-loading="saving" size="small" type="text" slot="reference">Transfer</el-button>

    <el-form size="small" :model="form" status-icon :rules="validationRules" ref="changeOfficeForm"
      @submit.native.prevent>
      <el-form-item label="Office" required prop="officeId">
        <el-select style="width: 100%" v-model="form.officeId" :clearable="false" placeholder="Select Office">
          <el-option v-for="item in allOffices" :key="item.id" :label="convertOfficeToRefType(item).name"
            :value="item.id" />
        </el-select>
      </el-form-item>
      <el-row class="mt-3 align-right">
        <el-button :disabled="saving" class="ml-3" size="small" type="text" @click="onCancel">Cancel</el-button>
        <el-button :disabled="saving" size="small" type="primary" @click="onSave">Save</el-button>
      </el-row>
    </el-form>
  </el-popover>
</template>

<script>
import { mapGetters } from 'vuex';
import OfficeToRefType from '@/util/OfficeToRefType';

export default {
  props: {
    value: {
      type: Number,
      required: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popoverVisible: false,
      form: {
        officeId: undefined,
      },
      validationRules: {
        officeId: [{ required: true }],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.form.officeId = val;
      },
    },
  },
  computed: {
    ...mapGetters('Lookup', ['allOffices']),
  },
  methods: {
    convertOfficeToRefType(office) {
      return OfficeToRefType(office);
    },
    async onSave() {
      try {
        await this.$refs.changeOfficeForm.validate();
      } catch (e) {
        // validation failed
        return;
      }

      this.$emit('update:value', this.form.officeId);
      this.popoverVisible = false;
    },
    onCancel() {
      this.form.officeId = this.value;
      this.popoverVisible = false;
    },
  },
};
</script>
